<ng-container *ngIf="fundDetails">
    <span
        *ngIf="fundDetails.CutOffTime"
        class="d-flex flex-wrap justify-content-center my-3">
        <img src="assets/img/Group.png" alt="">
        <span class="text-color-theme tx-18 font-600"> {{'fundMakeSure'|translate}}: {{fundDetails?.CutOffTime | date:'shortTime' }} {{'tradeWisley'|translate}} </span>
    </span>
</ng-container>
<div class="container-bg position-relative radius-20 p-4">
    <div
        class="p-2 IPO-card-header leaf  font-small" [style.left]="lang=='ar' ? '0':null"
        [style.right]="lang=='en' ? '0':null">
            {{lang=='ar'?fundDetails?.FundTypeAR:fundDetails?.FundTypeEN}}
    </div>
    <div class="row justify-content-between mx-0">
        <div class="text-start">
            <h3 class="text-color-theme font-xlarge font-600">{{selectedFund?.ClosePrice |numberFormat }} {{ lang=='ar'? selectedFund?.CurrencyAbbreviationA: selectedFund?.CurrencyAbbreviationE }}</h3>
            <div class="my-2">
                <span class="font-600"
                    [ngClass]="{
                        'green-text':selectedFund?.AnnualChangePercentage>0,
                        'red-text':selectedFund?.AnnualChangePercentage<0,
                        'text-color-theme':selectedFund?.AnnualChangePercentage==0 }"
                    >
                        {{ lang=='ar'? selectedFund?.CurrencyAbbreviationA: selectedFund?.CurrencyAbbreviationE }} {{selectedFund?.AnnualChange |numberFormat  }} ( % {{selectedFund?.AnnualChangePercentage |numberFormat }} ) {{'past-year'|translate}}
                    </span>
                    <img [src]="selectedFund.AnnualChangePercentage>0?'assets/img/up-arrow.svg':'assets/img/down-arrow.svg'" alt="">
            </div>
        </div>
    </div>

    <ng-container *ngIf=" (fundPriceChartData?.Data?.length >= 2) && (fundDetails?.FundTypeEN != 'Fixed Income') ">
        <!-- <ul class="d-flex flex-row align-items-center ">
            <li class="tab-item m-xl-2 m-lg-2 m-md-1 m-sm-1 m-xs-1 ">
                <button
                    class="selection-tab chart-tabs-active"
                    id="selecttab1"
                    (click)="saveTabState($event)"
                >
                1D
                </button>
            </li>
            <li class="tab-item m-xl-2 m-lg-2 m-md-1 m-sm-1 m-xs-1">
                <button
                    class="selection-tab "
                    id="selecttab2"
                    (click)="saveTabState($event)"
                >
                1W
                </button>
            </li>
            <li class="tab-item m-xl-2 m-lg-2 m-md-1 m-sm-1 m-xs-1 ">
                <button
                    class="selection-tab "
                    id="selecttab3"
                    (click)="saveTabState($event)"
                >
                4M
                </button>
            </li>
            <li class="tab-item m-xl-2 m-lg-2 m-md-1 m-sm-1 m-xs-1">
                <button
                    class="selection-tab "
                    id="selecttab4"
                    (click)="saveTabState($event)"
                >
                1Y
                </button>
            </li>
            <li class="tab-item m-xl-2 m-lg-2 m-md-1 m-sm-1 m-xs-1">
                <button
                    class="selection-tab "
                    id="selecttab4"
                    (click)="saveTabState($event)"
                >
                All
                </button>
            </li>
        </ul> -->

        <apx-chart
            [series]="chartOptions?.series"
            [chart]="chartOptions?.chart"
            [fill]="chartOptions?.fill"
            [grid]="chartOptions?.grid"
            [stroke]="chartOptions?.stroke"
            [xaxis]="chartOptions?.xaxis"
            [yaxis]="chartOptions?.yaxis"
            [dataLabels]="chartOptions?.dataLabels"
            [responsive]="chartOptions?.responsive"
        ></apx-chart>
    </ng-container>

    <!-- TODO:: 2 in this condition IS the number of min data to draw chart  -->
    <ng-container  *ngIf="fundDetails?.FundTypeEN != 'Fixed Income' && fundPriceChartData?.Data?.length < 2 ">
        <div
            class="nodata d-flex flex-column align-items-center justify-content-center"
        >
            <img class="img-not-found-width" src="/assets/img/no-data-vector.png" />
            <div class="no-data-available mt-2 font-600" > {{'no-data-available'|translate}} </div>
        </div>
    </ng-container>


      <ng-container *ngIf="fundDetails?.FundTypeEN == 'Fixed Income'">

        <div [dir]="lang === 'ar' ? 'rtl' : 'ltr'" class="custom-slider my-5">
            <ngx-slider [(value)]="value" [(highValue)]="LastMonthChange" [options]="monthoptions"></ngx-slider>
        </div>
        <div class="d-flex">
            <span class="dimmed-Title"> {{'returns-past-month' | translate}} : </span>
            <span class="text-highlight-company-color font-600"> %{{selectedFund?.LastMonthChangePercentage | numberFormat}}</span>
        </div>

        <div [dir]="lang === 'ar' ? 'rtl' : 'ltr'" class="custom-slider my-5">
            <ngx-slider [(value)]="value" [(highValue)]="AnnualChangePercentage" [options]="annualoptions">
            </ngx-slider>
        </div>
        <div class="d-flex">
            <span class="dimmed-Title " >{{'annual-revenue' | translate}} : </span> <span class="text-highlight-company-color font-600" > %{{selectedFund?.AnnualChangePercentage |numberFormat }}</span>
        </div>
    </ng-container>

</div>

<!-- *ngIf="symbolInfo?.InformationAr || symbolInfo?.InformationEn " -->
<div  class="d-flex flex-column mt-4">
    <div class="IPO-card">
        <div class="my-3 text-color-theme font-medium font-600 text-start">{{'mutualFundAbout'|translate}}</div>
        <div class="description-scroll">
        <ng-container *ngIf="fundDetails?.AboutAr || fundDetails?.AboutEn">
            <div class="my-3 override-inner-html-style dimmed-title-2 font-small text-start tablestyle" [innerHTML]="lang=='ar'?fundDetails?.AboutAr:fundDetails?.AboutEn"></div>
        </ng-container>
        <ng-container *ngIf="!fundDetails?.AboutAr && !fundDetails?.AboutEn">
        <div class="text-center nodata  d-flex flex-column align-items-center justify-content-center">
            <img class="img-not-found-width" src="/assets/img/no-data-vector.png" />
            <div class="no-data-available mt-2 font-600" > {{'no-data-available'|translate}} </div>
        </div>
        </ng-container>
        </div>
        <div class="row mx-0">
            <button class="my-3 green-outline-btn rounded-btn w-100" (click)="fundActionModal(true)">{{'buy'|translate}}</button>
            <button *ngIf="!hideSell" class="my-3 red-outline-btn  rounded-btn mx-2 w-100"  (click)="fundActionModal(false)">{{'Sell'|translate}}</button>
        </div>
    </div>
</div>
